/* eslint-disable */
// Events
// -----------------
// Thanks to:
//  - https://github.com/documentcloud/backbone/blob/master/backbone.js
//  - https://github.com/joyent/node/blob/master/lib/events.js

// Regular expression used to split event strings
const eventSplitter = /\s+/;

// A module that can be mixed in to *any object* in order to provide it
// with custom events. You may bind with `on` or remove with `off` callback
// functions to an event; `trigger`-ing an event fires all callbacks in
// succession.
//
//     var object = new Events();
//     object.on('expand', function(){ alert('expanded'); });
//     object.trigger('expand');
//
function Events() {}

// Bind one or more space separated events, `events`, to a `callback`
// function. Passing `"all"` will bind the callback to all events fired.
Events.prototype.on = function(events, callback, context) {
    let cache, event, list, namespace, a;

    if (!callback) return this;

    cache = this.__events || (this.__events = {});
    events = events.split(eventSplitter);

    while ((event = events.shift())) {
        a = event.split(':');
        event = a[0];
        namespace = a[1] || '';
        list = cache[event] || (cache[event] = []);
        list.push(callback, context, namespace);
    }

    return this;
};

Events.prototype.once = function(events, callback, context) {
    const that = this;
    var cb = function() {
        that.off(events, cb);
        callback.apply(this, arguments);
    };

    this.on(events, cb, context);
};

// Remove one or many callbacks. If `context` is null, removes all callbacks
// with that function. If `callback` is null, removes all callbacks for the
// event. If `events` is null, removes all bound callbacks for all events.
Events.prototype.off = function(events, callback, context) {
    let cache, event, list, i, namespace, a;

    // No events, or removing *all* events.
    if (!(cache = this.__events)) return this;
    if (!(events || callback || context)) {
        delete this.__events;

        return this;
    }

    events = events ? events.split(eventSplitter) : keys(cache);

    // Loop through the callback list, splicing where appropriate.
    while ((event = events.shift())) {
        a = event.split(':');
        namespace = a[1] || '';
        event = a[0];
        list = cache[event];
        if (!list) continue;

        if (!(callback || context || namespace !== '')) {
            delete cache[event];
            continue;
        }

        for (i = list.length - 3; i >= 0; i -= 3) {
            if (
                !(
                    (callback && list[i] !== callback) ||
                    (context && list[i + 1] !== context) ||
                    (namespace !== '' && list[i + 2] !== namespace)
                )
            ) {
                list.splice(i, 3);
            }
        }
    }

    return this;
};

// Trigger one or many events, firing all bound callbacks. Callbacks are
// passed the same arguments as `trigger` is, apart from the event name
// (unless you're listening on `"all"`, which will cause your callback to
// receive the true name of the event as the first argument).
Events.prototype.trigger = function(events) {
    let cache;

    let event;

    let all;

    let list;

    let i;

    let len;

    const rest = [];

    let args;

    let returned = true;

    if (!(cache = this.__events)) return this;

    events = events.split(eventSplitter);

    // Fill up `rest` with the callback arguments.  Since we're only copying
    // the tail of `arguments`, a loop is much faster than Array#slice.
    for (i = 1, len = arguments.length; i < len; i++) {
        rest[i - 1] = arguments[i];
    }

    // For each event, walk through the list of callbacks twice, first to
    // trigger the event, then to trigger any `"all"` callbacks.
    while ((event = events.shift())) {
        // Copy callback lists to prevent modification.
        if ((all = cache.all)) all = all.slice();
        if ((list = cache[event])) list = list.slice();

        // Execute event callbacks.
        returned = triggerEvents(list, rest, this) && returned;

        // Execute "all" callbacks.
        returned = triggerEvents(all, [event].concat(rest), this) && returned;
    }

    return returned;
};

Events.prototype.emit = Events.prototype.trigger;

// Mix `Events` to object instance or Class function.
Events.mixTo = function(receiver) {
    receiver = isFunction(receiver) ? receiver.prototype : receiver;
    const proto = Events.prototype;

    for (const p in proto) {
        if (proto.hasOwnProperty(p)) {
            receiver[p] = proto[p];
        }
    }
};

// Helpers
// -------

var keys = Object.keys;

if (!keys) {
    keys = function(o) {
        const result = [];

        for (const name in o) {
            if (o.hasOwnProperty(name)) {
                result.push(name);
            }
        }

        return result;
    };
}

// Execute callbacks
function triggerEvents(list, args, context) {
    let pass = true;

    if (list) {
        let i = 0;

        const l = list.length;

        const a1 = args[0];

        const a2 = args[1];

        const a3 = args[2];
        // call is faster than apply, optimize less than 3 argu
        // http://blog.csdn.net/zhengyinhui100/article/details/7837127

        switch (args.length) {
            case 0:
                for (; i < l; i += 3) {
                    pass = list[i].call(list[i + 1] || context) !== false && pass;
                }
                break;
            case 1:
                for (; i < l; i += 3) {
                    pass = list[i].call(list[i + 1] || context, a1) !== false && pass;
                }
                break;
            case 2:
                for (; i < l; i += 3) {
                    pass = list[i].call(list[i + 1] || context, a1, a2) !== false && pass;
                }
                break;
            case 3:
                for (; i < l; i += 3) {
                    pass = list[i].call(list[i + 1] || context, a1, a2, a3) !== false && pass;
                }
                break;
            default:
                for (; i < l; i += 3) {
                    pass = list[i].apply(list[i + 1] || context, args) !== false && pass;
                }
                break;
        }
    }
    // trigger will return false if one of the callbacks return false
    return pass;
}

function isFunction(func) {
    return Object.prototype.toString.call(func) === '[object Function]';
}

export default Events;
